import React, {RefObject} from 'react';
import {TChat} from 'modules/chat';
import {JAVASCRIPT_VOID} from 'constants/config';
import ChatData from 'components/player/chat/ChatData';
import {t} from 'lib/i18n';

interface IChatProps {
  seekTime: string;
  chats: TChat[];
  chatAreaRef: RefObject<HTMLDivElement>;
  chatMemoRef: RefObject<HTMLDivElement>;
  downBtn: string;
  onScrollDown: () => void;
  onClickHideChat: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const Chat = ({
  seekTime,
  chats,
  chatAreaRef,
  chatMemoRef,
  downBtn,
  onScrollDown,
  onClickHideChat,
}: IChatProps) => {
  return (
    <div id='chatting_area' className='chatting_area chat_thema_dark'>
      <div className='chatbox'>
        <div className='area_header'>
          <div className='chat_title'>
            <h2>
              <span>{t('채팅')}</span>
            </h2>
            <ul>
              <li className='close'>
                {
                  <a
                    className='tip-right'
                    title={t('채팅영역 숨기기')}
                    href={JAVASCRIPT_VOID}
                    onClick={onClickHideChat}>
                    {t('채팅영역 숨기기')}
                  </a>
                }
              </li>
            </ul>
          </div>
        </div>
        <div className='chatting-item-wrap'>
          <div className='chatting-viewer' ref={chatAreaRef}>
            <div className='chat_memoyo' ref={chatMemoRef}>
              <div className='chatting-list-item' id='boxVstart'>
                <div className='start-message'>
                  <p className='msg'>
                    {t('{{time}} 이후에 저장된 채팅 입니다.', {
                      placeholder: {
                        time: seekTime === '' ? '00:00:00' : seekTime,
                      },
                    })}
                  </p>
                </div>
              </div>
              {chats.map((chat) => (
                <ChatData chatText={chat.text} key={chat.id} />
              ))}
            </div>
          </div>
        </div>
        <div className={'chat_scroll_down ' + downBtn}>
          <button type='button' className='scroll_down' onClick={onScrollDown}>
            {t('채팅 아래로 스크롤')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Chat;
